const locale = {
	NO_MATCHING_RECORDS_FOUND: 'テーブル内のデータなし',
	users_list_title: 'ユーザー',
	admins_list_title: 'ダッシュボード',
	dashboard_admin_title: '管理者ダッシュボード',
	search_admin: '管理者を検索',
	search_user: 'ユーザーを検索',
	search_project:'現場を検索',
	map_member: '関連ユーザー',
	view_project:'現場を見る',
	cancel: 'キャンセル',
	delete:'削除',
	deactivate:'無効化',
	submit:'登録',
	remove:'削除',
	edit_details: '詳細を編集',
	change_password: 'パスワード変更',
	deactivate_account: 'アカウントを無効化',
	resend_welcome_email: '再有効化',
	new_password: '新パスワード',
	enter_new_password: '新パスワードを入力',
	confirm_password:'再入力',
	enter_confirm_password:'同じパスワードを入力',
	update_password: 'パスワードを更新',
	recover_account: 'アカウントを復帰',
	activate_account:'アカウントを有効化',
	companies: '会社',
	dashboard:'ダッシュボード',
	member_type: 'ユーザー種類',
	group_type: 'グループ',
	affiliation: '所属',
	account_status: 'アカウント状況',
	reset_filters: '絞り込みをリセット',
	filter_by: '絞り込み条件 :',
	export:'ファイルに出力',
};

export default locale;